const labels = {
  type: 'Report type'
}

export default {
  queue: { labels },
  recurrent: { labels }
}
